import { CreditCard } from '../models/model';
import { removeCardNumberSpacing } from './remove-card-number-spacing';
import { CardBrand } from '../models/card-brand.enum';

export function cardDescription(creditCard: CreditCard): string {
  return creditCard.brand === CardBrand.UNDEFINED
    ? ''
    : creditCard.brand.charAt(0).toUpperCase() + creditCard.brand.slice(1).toLowerCase();
}

export function cardFullDescription(card: CreditCard): string {
  const descriptionWithNumber = cardDescription(card) + ' •••• •••• •••• ' + removeCardNumberSpacing(card.maskedNumber);
  const { label } = card;
  return label ? `${label} (${descriptionWithNumber})` : descriptionWithNumber;
}
